import * as React from 'react';
import { useCallback, useMemo } from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import FooterStore from './store';
import LanguageSelect from '@src/business-components/common-language-select';
import Link from '@src/components/link';
import ToTopBtn from '@src/business-components/to-top-btn';

// 认证标识组件
const TrusteBadges = React.memo(({ badges = [] }) => {
  return (
    <React.Fragment>
      {badges.map((item, index) => {
        if (!item.img) return null;
        return item.url ? (
          <Link key={index} href={item.url}  >
            <img src={item.img} />
          </Link>
        ) : (
          <img key={index} src={item.img} />
        );
      })}
    </React.Fragment>
  );
});

// 媒体列表组件
const MediaList = React.memo(({ itemList = [], onRedirectLink }) => {
  return (
    <div className={styles.channelList}>
      {itemList.map((item, key) => (
        <div
          className={styles.listItem}
          key={key}
          onClick={() => onRedirectLink(item.link)}
        >
          <img src={item.img} />
        </div>
      ))}
    </div>
  );
});

// 协议链接组件
const AgreementLinks = React.memo(({ links = [], onCookieSetting }) => {
  const filteredLinks = useMemo(() =>
    links.filter(item => item.text),
    [links]
  );

  return (
    <div className={styles.footer_agreem_list}>
      {filteredLinks.map((item, index) => (
        <React.Fragment key={index}>
          {item.href ? (
            <Link
              href={item.href}
              target="_blank"
              className={item.isFontWeight ? styles.fontWeight : undefined}
            >
              {item.text}
            </Link>
          ) : (
            <Link onClick={() => item.cookieSetting && onCookieSetting()}>
              {item.text}
            </Link>
          )}
          {index < filteredLinks.length - 1 && <span className={styles.agreem_line} />}
        </React.Fragment>
      ))}
    </div>
  );
});

// 版权信息组件
const CopyrightInfo = React.memo(({ textInfo = [] }) => {
  const filteredTextInfo = useMemo(() =>
    textInfo.filter(item => item.text),
    [textInfo]
  );

  return (
    <React.Fragment>
      {filteredTextInfo.map((item, index) => (
        <div key={index} className={styles.copyRight}>
          {item.href ? (
            <Link href={item.href} target="_blank">
              {item.text}
            </Link>
          ) : (
            item.text
          )}
        </div>
      ))}
    </React.Fragment>
  );
});

const Footer = ({ store }) => {
  store.use();

  // 使用 useCallback 缓存回调函数
  const handleRedirectLink = useCallback((url) => {
    store.onRedirectLink(url);
  }, [store]);

  const handleCookieSetting = useCallback(() => {
    store.handleCookieSetting();
  }, [store]);

  return (
    <div className={styles.footerRoot}>
      {store.isRenderMediaList && (
        <MediaList
          itemList={store.itemList}
          onRedirectLink={handleRedirectLink}
        />
      )}

      <div className={styles.content}>
        {/* 语言选择器 */}
        <div className={styles.footer_language_container}>
          <LanguageSelect
            store={store.languageSelectStore}
            buttonType="footer"
            displayPosition="above"
          />
        </div>

        {/* 主Logo */}
        {store.footerTopLogo.map((item, index) => {
          const logoClassName = index === 0 ? `${styles.logo} ${styles.firstLogo}` : styles.logo;
          return item.url ? (
            <Link className={logoClassName} key={index} href={item.url}>
              <img src={item.img} />
            </Link>
          ) : (
            <img className={logoClassName} key={index} src={item.img} />
          );
        })}

        {/* 协议链接 */}
        <AgreementLinks
          links={store.agreementLinks}
          onCookieSetting={handleCookieSetting}
        />

        {/* 版权信息 */}
        <CopyrightInfo textInfo={store.footerTextInfo} />

        {/* 认证标识 */}
        <div className={styles.truste}>
          <TrusteBadges badges={store.footerLeftLogo} />
        </div>

        {/* 返回顶部按钮 */}
        <div className={styles.footer_backTopBtn}>
          <ToTopBtn store={store.toTopBtnStore} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(Footer, FooterStore);
